import { FETCH_SAVED_SALES_TEMPLATE } from "../../constants/action.constants";

const initialState = {
  list: [],
};

const savedSalesTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SAVED_SALES_TEMPLATE:
      return { list: action.payload };
    default:
      return state;
  }
};

export default savedSalesTemplateReducer;
